// index.js
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n/i18n"; // Import cấu hình i18n
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
